// 2023 Topps Star Wars — the first paper flagship set (hobby Super Box + value
// blaster; released August 4, 2023; SKUs 5358 hobby / 5359 value blaster SE).
// Cards verified against Cardboard Connection cross-checked with TCDB (base names and
// all 18 autograph codes agree); parallels and odds from the official Topps odds sheet
// (2023-Topps-Star-Wars-odds-PDF-document.pdf, Cardboard Connection S3 mirror — the
// checklist is no longer on topps.com).
// Gold Foil is the value-blaster-exclusive entry parallel (unnumbered, no hobby odds);
// Rainbow Foil is the hobby entry parallel. Two 1/1 tiers exist: Hyperspace and
// Printing Plates.
// Verbatim printed-card text kept on purpose — do not "fix": DW-29 "Debra Meero" and
// DW-30 "Marva Andor" are Topps' own typos (Dedra/Maarva), confirmed on eBay specimens.
// KYBER CRYSTAL DIE-CUTS: numbering continues across the 2023 Topps line — KCD-1..5
// are in 2023 Chrome, this set carries KCD-6..10 (specimen-confirmed; SGC-slabbed
// KCD-10 exists), Chrome Black continues higher.
// AUTOGRAPHS: Topps never published a full roster; the 18 cards below are the
// community-confirmed list (Cardboard Connection + TCDB agree). AU-KF Karen Fukuhara
// signed as "F", the Jedi from the Visions short "The Village Bride".
// The SDCC promo (#0 Jabba the Hutt) was exclusive to 2023 SDCC packs and carries the
// foilboard ladder only.

const BASE_P = [
  {id:"rainbow-foil",name:"Rainbow Foil",print_run:null,color:"#c8d8f0"},
  {id:"gold-foil",name:"Gold Foil",print_run:null,color:"#f0c040"},
  {id:"green-foil",name:"Green Foil",print_run:499,color:"#8fdf8f"},
  {id:"orange-foil",name:"Orange Foil",print_run:299,color:"#ff9d52"},
  {id:"red-foil",name:"Red Foil",print_run:199,color:"#ff9d8a"},
  {id:"purple",name:"Purple",print_run:99,color:"#b060ff"},
  {id:"black",name:"Black",print_run:75,color:"#a8a8b4"},
  {id:"blue",name:"Blue",print_run:50,color:"#4d9fff"},
  {id:"green",name:"Green",print_run:25,color:"#00e676"},
  {id:"red",name:"Red",print_run:10,color:"#ff5d5d"},
  {id:"hyperspace",name:"Hyperspace",print_run:1,color:"#b0e0ff"},
  {id:"printing-plates",name:"Printing Plates",print_run:1,color:"#b0b0b8"},
];

const INSERT_P = [
  {id:"blue",name:"Blue",print_run:50,color:"#4d9fff"},
  {id:"green",name:"Green",print_run:25,color:"#00e676"},
  {id:"red",name:"Red",print_run:10,color:"#ff5d5d"},
  {id:"hyperspace",name:"Hyperspace",print_run:1,color:"#b0e0ff"},
];

export const SETS = [
  {
    id: "base", type: "base", title: "BASE SET — 100 CARDS",
    parallels: BASE_P,
    cards: [
      {n:"1", name:"Ahsoka Tano", artist:null},
      {n:"2", name:"Magistrate Morgan Elsbeth", artist:null},
      {n:"3", name:"The Mandalorian", artist:null},
      {n:"4", name:"Kuiil", artist:null},
      {n:"5", name:"8D8", artist:null},
      {n:"6", name:"EV-9D9", artist:null},
      {n:"7", name:"D-0", artist:null},
      {n:"8", name:"B2EMO", artist:null},
      {n:"9", name:"Moff Gideon", artist:null},
      {n:"10", name:"Dr. Pershing", artist:null},
      {n:"11", name:"Finn", artist:null},
      {n:"12", name:"Captain Carson Teva", artist:null},
      {n:"13", name:"Lieutenant Reed", artist:null},
      {n:"14", name:"Jib Dodger", artist:null},
      {n:"15", name:"Kleya Marki", artist:null},
      {n:"16", name:"Luthen Rael", artist:null},
      {n:"17", name:"Saw Gerrera", artist:null},
      {n:"18", name:"Bo-Katan Kryze", artist:null},
      {n:"19", name:"Koska Reeves", artist:null},
      {n:"20", name:"Axe Woves", artist:null},
      {n:"21", name:"Hondo Ohnaka", artist:null},
      {n:"22", name:"Hera Syndulla", artist:null},
      {n:"23", name:"Jarek Yeager", artist:null},
      {n:"24", name:"Tam Ryvora", artist:null},
      {n:"25", name:"Torra Doza", artist:null},
      {n:"26", name:"Synara San", artist:null},
      {n:"27", name:"Neeku Vozo", artist:null},
      {n:"28", name:"Ezra Bridger", artist:null},
      {n:"29", name:"Zeb Orrelios", artist:null},
      {n:"30", name:"Owen Lars", artist:null},
      {n:"31", name:"Beru Lars", artist:null},
      {n:"32", name:"The Armorer", artist:null},
      {n:"33", name:"Paz Vizsla", artist:null},
      {n:"34", name:"Bix Caleen", artist:null},
      {n:"35", name:"Brasso", artist:null},
      {n:"36", name:"Maarva Andor", artist:null},
      {n:"37", name:"Clem Andor", artist:null},
      {n:"38", name:"Toro Calican", artist:null},
      {n:"39", name:"Fennec Shand", artist:null},
      {n:"40", name:"Dokk Strassi", artist:null},
      {n:"41", name:"Tala Durith", artist:null},
      {n:"42", name:"Reva", artist:null},
      {n:"43", name:"The Grand Inquisitor", artist:null},
      {n:"44", name:"Cal Kestis", artist:null},
      {n:"45", name:"Second Sister", artist:null},
      {n:"46", name:"Cere Junda", artist:null},
      {n:"47", name:"Luke Skywalker", artist:null},
      {n:"48", name:"Minas Velti", artist:null},
      {n:"49", name:"Corran", artist:null},
      {n:"50", name:"Sully", artist:null},
      {n:"51", name:"Twi'lek Server", artist:null},
      {n:"52", name:"Garsa Fwip", artist:null},
      {n:"53", name:"Krrsantan", artist:null},
      {n:"54", name:"Boba Fett", artist:null},
      {n:"55", name:"Tusken Chief", artist:null},
      {n:"56", name:"Tusken Warrior", artist:null},
      {n:"57", name:"Arvel Skeen", artist:null},
      {n:"58", name:"Taramyn Barcona", artist:null},
      {n:"59", name:"Karis Nemik", artist:null},
      {n:"60", name:"Cinta Kaz", artist:null},
      {n:"61", name:"Vel Sartha", artist:null},
      {n:"62", name:"Lieutenant Gorn", artist:null},
      {n:"63", name:"Qui-Gon Jinn", artist:null},
      {n:"64", name:"Obi-Wan Kenobi", artist:null},
      {n:"65", name:"Tetha Grig", artist:null},
      {n:"66", name:"Vect Nokru", artist:null},
      {n:"67", name:"Princess Leia", artist:null},
      {n:"68", name:"Mon Mothma", artist:null},
      {n:"69", name:"Leida", artist:null},
      {n:"70", name:"Perrin Fertha", artist:null},
      {n:"71", name:"Babu Frik", artist:null},
      {n:"72", name:"Salacious B. Crumb", artist:null},
      {n:"73", name:"Sebulba", artist:null},
      {n:"74", name:"Zorii Bliss", artist:null},
      {n:"75", name:"Cassian Andor", artist:null},
      {n:"76", name:"Vetch", artist:null},
      {n:"77", name:"Major Partagaz", artist:null},
      {n:"78", name:"Lieutenant Supervisor Blevin", artist:null},
      {n:"79", name:"Dedra Meero", artist:null},
      {n:"80", name:"Syril Karn", artist:null},
      {n:"81", name:"Cad Bane", artist:null},
      {n:"82", name:"Kino Loy", artist:null},
      {n:"83", name:"Nien Nunb", artist:null},
      {n:"84", name:"Quinlan Vos", artist:null},
      {n:"85", name:"Jyn Erso", artist:null},
      {n:"86", name:"Han Solo", artist:null},
      {n:"87", name:"Princess Leia Organa", artist:null},
      {n:"88", name:"Grogu", artist:null},
      {n:"89", name:"Darth Vader", artist:null},
      {n:"90", name:"Yoda", artist:null},
      {n:"91", name:"Rey", artist:null},
      {n:"92", name:"Padmé Amidala", artist:null},
      {n:"93", name:"Chewbacca", artist:null},
      {n:"94", name:"C-3PO", artist:null},
      {n:"95", name:"R2-D2", artist:null},
      {n:"96", name:"BB-8", artist:null},
      {n:"97", name:"Darth Maul", artist:null},
      {n:"98", name:"Mace Windu", artist:null},
      {n:"99", name:"Lando Calrissian", artist:null},
      {n:"100", name:"Emperor Palpatine", artist:null},
    ]
  },
  {
    id: "sdcc-promo", type: "insert", title: "SDCC PROMO — 1 CARD",
    parallels: [
      {id:"rainbow-foil",name:"Rainbow Foil",print_run:null,color:"#c8d8f0"},
      {id:"gold-foil",name:"Gold Foil",print_run:null,color:"#f0c040"},
      {id:"green-foil",name:"Green Foil",print_run:499,color:"#8fdf8f"},
      {id:"orange-foil",name:"Orange Foil",print_run:299,color:"#ff9d52"},
      {id:"red-foil",name:"Red Foil",print_run:199,color:"#ff9d8a"},
    ],
    cards: [
      {n:"0", name:"Jabba the Hutt", artist:null},
    ]
  },
  {
    id: "comic-covers", type: "insert", title: "COMIC COVERS — 30 CARDS",
    parallels: INSERT_P,
    cards: [
      {n:"CC-1", name:"Captain Phasma #4", artist:null},
      {n:"CC-2", name:"Captain Phasma #1", artist:null},
      {n:"CC-3", name:"Chewbacca #2", artist:null},
      {n:"CC-4", name:"Darth Vader #13", artist:null},
      {n:"CC-5", name:"Darth Vader #17", artist:null},
      {n:"CC-6", name:"Darth Vader #22", artist:null},
      {n:"CC-7", name:"Darth Vader #2", artist:null},
      {n:"CC-8", name:"Darth Vader #5", artist:null},
      {n:"CC-9", name:"Darth Vader #10", artist:null},
      {n:"CC-10", name:"Darth Maul #2", artist:null},
      {n:"CC-11", name:"Darth Vader #6", artist:null},
      {n:"CC-12", name:"Han Solo #4", artist:null},
      {n:"CC-13", name:"Kanan #6", artist:null},
      {n:"CC-14", name:"Lando #3", artist:null},
      {n:"CC-15", name:"Lando #2", artist:null},
      {n:"CC-16", name:"Obi-Wan & Anakin #1", artist:null},
      {n:"CC-17", name:"Poe Dameron #22", artist:null},
      {n:"CC-18", name:"Poe Dameron #24", artist:null},
      {n:"CC-19", name:"Poe Dameron #2", artist:null},
      {n:"CC-20", name:"Poe Dameron #7", artist:null},
      {n:"CC-21", name:"Poe Dameron #17", artist:null},
      {n:"CC-22", name:"Star Wars #5", artist:null},
      {n:"CC-23", name:"Star Wars #8", artist:null},
      {n:"CC-24", name:"Star Wars #10", artist:null},
      {n:"CC-25", name:"Star Wars #11", artist:null},
      {n:"CC-26", name:"Star Wars #12", artist:null},
      {n:"CC-27", name:"Star Wars #15", artist:null},
      {n:"CC-28", name:"Star Wars #59", artist:null},
      {n:"CC-29", name:"Vader Down #1", artist:null},
      {n:"CC-30", name:"Star Wars #14", artist:null},
    ]
  },
  {
    id: "epic-clashes", type: "insert", title: "EPIC CLASHES — 20 CARDS",
    parallels: INSERT_P,
    cards: [
      {n:"EC-1", name:"Obi-Wan Kenobi / Darth Maul", artist:null},
      {n:"EC-2", name:"Qui-Gon Jinn / Darth Maul", artist:null},
      {n:"EC-3", name:"Mace Windu / Jango Fett", artist:null},
      {n:"EC-4", name:"Yoda / Count Dooku", artist:null},
      {n:"EC-5", name:"Anakin Skywalker / Count Dooku", artist:null},
      {n:"EC-6", name:"Obi-Wan Kenobi / Count Dooku", artist:null},
      {n:"EC-7", name:"Obi-Wan Kenobi / General Grievous", artist:null},
      {n:"EC-8", name:"Mace Windu / Palpatine", artist:null},
      {n:"EC-9", name:"Obi-Wan Kenobi / Anakin Skywalker", artist:null},
      {n:"EC-10", name:"Yoda / Darth Sidious", artist:null},
      {n:"EC-11", name:"Obi-Wan Kenobi / Anakin Skywalker", artist:null},
      {n:"EC-12", name:"Obi-Wan Kenobi / Darth Vader", artist:null},
      {n:"EC-13", name:"Luke Skywalker / Darth Vader", artist:null},
      {n:"EC-14", name:"Luke Skywalker / Darth Vader", artist:null},
      {n:"EC-15", name:"Ahsoka Tano / Magistrate Morgan Elsbeth", artist:null},
      {n:"EC-16", name:"The Mandalorian / Moff Gideon", artist:null},
      {n:"EC-17", name:"Rey / Kylo Ren", artist:null},
      {n:"EC-18", name:"Rey / The Praetorian Guards", artist:null},
      {n:"EC-19", name:"Kylo Ren / The Praetorian Guards", artist:null},
      {n:"EC-20", name:"Luke Skywalker / Kylo Ren", artist:null},
    ]
  },
  {
    id: "into-the-galaxy", type: "insert", title: "INTO THE GALAXY — 30 CARDS",
    parallels: INSERT_P,
    cards: [
      {n:"IG-1", name:"Tatooine", artist:null},
      {n:"IG-2", name:"Coruscant", artist:null},
      {n:"IG-3", name:"Kashyyyk", artist:null},
      {n:"IG-4", name:"Bespin", artist:null},
      {n:"IG-5", name:"Naboo", artist:null},
      {n:"IG-6", name:"Hoth", artist:null},
      {n:"IG-7", name:"Mustafar", artist:null},
      {n:"IG-8", name:"Kamino", artist:null},
      {n:"IG-9", name:"Dagobah", artist:null},
      {n:"IG-10", name:"Mandalore", artist:null},
      {n:"IG-11", name:"Alderaan", artist:null},
      {n:"IG-12", name:"Yavin", artist:null},
      {n:"IG-13", name:"Geonosis", artist:null},
      {n:"IG-14", name:"Jakku", artist:null},
      {n:"IG-15", name:"Felucia", artist:null},
      {n:"IG-16", name:"Corellia", artist:null},
      {n:"IG-17", name:"Nal Hutta", artist:null},
      {n:"IG-18", name:"Mon Cala", artist:null},
      {n:"IG-19", name:"Starkiller Base", artist:null},
      {n:"IG-20", name:"Ryloth", artist:null},
      {n:"IG-21", name:"Serenno", artist:null},
      {n:"IG-22", name:"Lothal", artist:null},
      {n:"IG-23", name:"Crait", artist:null},
      {n:"IG-24", name:"Death Star", artist:null},
      {n:"IG-25", name:"Endor", artist:null},
      {n:"IG-26", name:"Scarif", artist:null},
      {n:"IG-27", name:"Jedha", artist:null},
      {n:"IG-28", name:"Takodana", artist:null},
      {n:"IG-29", name:"Ahch-To", artist:null},
      {n:"IG-30", name:"Nevarro", artist:null},
    ]
  },
  {
    id: "lightsaber-stylings", type: "insert", title: "LIGHTSABER STYLINGS DIE-CUTS — 20 CARDS",
    parallels: INSERT_P,
    cards: [
      {n:"LS-1", name:"Luke Skywalker", artist:null},
      {n:"LS-2", name:"Ahsoka Tano", artist:null},
      {n:"LS-3", name:"Yoda", artist:null},
      {n:"LS-4", name:"Obi-Wan Kenobi", artist:null},
      {n:"LS-5", name:"Rey", artist:null},
      {n:"LS-6", name:"Qui-Gon Jinn", artist:null},
      {n:"LS-7", name:"Mace Windu", artist:null},
      {n:"LS-8", name:"Ki-Adi-Mundi", artist:null},
      {n:"LS-9", name:"Kit Fisto", artist:null},
      {n:"LS-10", name:"Ezra Bridger", artist:null},
      {n:"LS-11", name:"Darth Vader", artist:null},
      {n:"LS-12", name:"Kylo Ren", artist:null},
      {n:"LS-13", name:"Darth Maul", artist:null},
      {n:"LS-14", name:"Count Dooku", artist:null},
      {n:"LS-15", name:"Kanan Jarrus", artist:null},
      {n:"LS-16", name:"Darth Sidious", artist:null},
      {n:"LS-17", name:"Moff Gideon", artist:null},
      {n:"LS-18", name:"Asajj Ventress", artist:null},
      {n:"LS-19", name:"General Grievous", artist:null},
      {n:"LS-20", name:"The Grand Inquisitor", artist:null},
    ]
  },
  {
    id: "character-image", type: "insert", title: "CHARACTER IMAGE SHORT PRINTS — 20 CARDS",
    parallels: [],
    cards: [
      {n:"CI-1", name:"Ahsoka Tano", artist:null},
      {n:"CI-2", name:"The Mandalorian", artist:null},
      {n:"CI-3", name:"Luke Skywalker", artist:null},
      {n:"CI-4", name:"Obi-Wan Kenobi", artist:null},
      {n:"CI-5", name:"Han Solo", artist:null},
      {n:"CI-6", name:"General Leia Organa", artist:null},
      {n:"CI-7", name:"Grogu", artist:null},
      {n:"CI-8", name:"Darth Vader", artist:null},
      {n:"CI-9", name:"Rey", artist:null},
      {n:"CI-10", name:"Chewbacca", artist:null},
      {n:"CI-11", name:"C-3PO", artist:null},
      {n:"CI-12", name:"R2-D2", artist:null},
      {n:"CI-13", name:"Kylo Ren", artist:null},
      {n:"CI-14", name:"Maul", artist:null},
      {n:"CI-15", name:"Cassian Andor", artist:null},
      {n:"CI-16", name:"Boba Fett", artist:null},
      {n:"CI-17", name:"Jabba the Hutt", artist:null},
      {n:"CI-18", name:"Yoda", artist:null},
      {n:"CI-19", name:"Poe Dameron", artist:null},
      {n:"CI-20", name:"Emperor Palpatine", artist:null},
    ]
  },
  {
    id: "aka", type: "insert", title: "AKA — 10 CARDS",
    parallels: [],
    cards: [
      {n:"AK-1", name:"Chewbacca - Chewie", artist:null},
      {n:"AK-2", name:"Anakin Skywalker - The Chosen One", artist:null},
      {n:"AK-3", name:"The Mandalorian - Mando", artist:null},
      {n:"AK-4", name:"Grogu - The Child", artist:null},
      {n:"AK-5", name:"Cassian Andor - Keef Girgo", artist:null},
      {n:"AK-6", name:"Black Krrsantan - Santo", artist:null},
      {n:"AK-7", name:"Luke Skywalker - Kid", artist:null},
      {n:"AK-8", name:"Ahsoka Tano - Fulcrum", artist:null},
      {n:"AK-9", name:"R2-D2 - Artoo", artist:null},
      {n:"AK-10", name:"C-3PO - Threepio", artist:null},
    ]
  },
  {
    id: "holograms", type: "insert", title: "HOLOGRAMS — 20 CARDS",
    parallels: [],
    cards: [
      {n:"HC-1", name:"Rogue One", artist:null},
      {n:"HC-2", name:"A New Hope", artist:null},
      {n:"HC-3", name:"A New Hope", artist:null},
      {n:"HC-4", name:"Attack of the Clones", artist:null},
      {n:"HC-5", name:"A New Hope", artist:null},
      {n:"HC-6", name:"The Empire Strikes Back", artist:null},
      {n:"HC-7", name:"The Empire Strikes Back", artist:null},
      {n:"HC-8", name:"Rogue One", artist:null},
      {n:"HC-9", name:"The Force Awakens", artist:null},
      {n:"HC-10", name:"The Rise of Skywalker", artist:null},
      {n:"HC-11", name:"Solo", artist:null},
      {n:"HC-12", name:"Resistance", artist:null},
      {n:"HC-13", name:"Rebels", artist:null},
      {n:"HC-14", name:"The Bad Batch", artist:null},
      {n:"HC-15", name:"The Mandalorian", artist:null},
      {n:"HC-16", name:"Obi-Wan Kenobi", artist:null},
      {n:"HC-17", name:"Andor", artist:null},
      {n:"HC-18", name:"The Clone Wars", artist:null},
      {n:"HC-19", name:"The Bad Batch", artist:null},
      {n:"HC-20", name:"The Clone Wars", artist:null},
    ]
  },
  {
    id: "widevision", type: "insert", title: "WIDEVISION — 40 CARDS",
    parallels: [],
    cards: [
      {n:"DW-1", name:"Boba Fett", artist:null},
      {n:"DW-2", name:"Jabba's Palace", artist:null},
      {n:"DW-3", name:"Boba Fett", artist:null},
      {n:"DW-4", name:"The Rancor", artist:null},
      {n:"DW-5", name:"Nikto Biker Gang", artist:null},
      {n:"DW-6", name:"Fennec Shand", artist:null},
      {n:"DW-7", name:"Sand Ape", artist:null},
      {n:"DW-8", name:"The Twins", artist:null},
      {n:"DW-9", name:"The Mandalorian", artist:null},
      {n:"DW-10", name:"Grogu", artist:null},
      {n:"DW-11", name:"Teeka", artist:null},
      {n:"DW-12", name:"Princess Leia", artist:null},
      {n:"DW-13", name:"The Inquisitors", artist:null},
      {n:"DW-14", name:"Reva", artist:null},
      {n:"DW-15", name:"Obi-Wan & Princess Leia", artist:null},
      {n:"DW-16", name:"Reva", artist:null},
      {n:"DW-17", name:"Darth Vader", artist:null},
      {n:"DW-18", name:"No Escape", artist:null},
      {n:"DW-19", name:"Obi-Wan & Darth Vader", artist:null},
      {n:"DW-20", name:"Obi-Wan & Owen Lars", artist:null},
      {n:"DW-21", name:"Morlana One", artist:null},
      {n:"DW-22", name:"Luthen Rael", artist:null},
      {n:"DW-23", name:"Imperial Security Droid", artist:null},
      {n:"DW-24", name:"Cassian Andor", artist:null},
      {n:"DW-25", name:"Imperial Security Bureau Chambers", artist:null},
      {n:"DW-26", name:"Mon Mothma", artist:null},
      {n:"DW-27", name:"Kino Loy", artist:null},
      {n:"DW-28", name:"Arrestor Cruiser", artist:null},
      {n:"DW-29", name:"Debra Meero", artist:null},
      {n:"DW-30", name:"Marva Andor", artist:null},
      {n:"DW-31", name:"Count Dooku & Mace Windu", artist:null},
      {n:"DW-32", name:"Senator Dagonet's Forces Arrive", artist:null},
      {n:"DW-33", name:"Count Dooku & Qui-Gon Jinn", artist:null},
      {n:"DW-34", name:"The Raxshir", artist:null},
      {n:"DW-35", name:"Ahsoka's Training", artist:null},
      {n:"DW-36", name:"Ahsoka Tano", artist:null},
      {n:"DW-37", name:"Ahsoka Tano", artist:null},
      {n:"DW-38", name:"A Sinister Inquisitor", artist:null},
      {n:"DW-39", name:"Count Dooku", artist:null},
      {n:"DW-40", name:"Yaddle", artist:null},
    ]
  },
  {
    id: "kyber-crystal-die-cuts", type: "insert", title: "KYBER CRYSTAL DIE-CUTS — 5 CARDS",
    parallels: [],
    cards: [
      {n:"KCD-6", name:"Kylo Ren", artist:null},
      {n:"KCD-7", name:"Rey", artist:null},
      {n:"KCD-8", name:"Luke Skywalker", artist:null},
      {n:"KCD-9", name:"Ahsoka Tano", artist:null},
      {n:"KCD-10", name:"Anakin Skywalker", artist:null},
    ]
  },
  {
    id: "autographs", type: "auto", title: "AUTOGRAPHS — 18 CARDS",
    parallels: [
      {id:"purple",name:"Purple",print_run:99,color:"#b060ff"},
      {id:"black",name:"Black",print_run:75,color:"#a8a8b4"},
      {id:"blue",name:"Blue",print_run:50,color:"#4d9fff"},
      {id:"green",name:"Green",print_run:25,color:"#00e676"},
      {id:"red",name:"Red",print_run:10,color:"#ff5d5d"},
      {id:"hyperspace",name:"Hyperspace",print_run:1,color:"#b0e0ff"},
      {id:"printing-plates",name:"Printing Plates",print_run:1,color:"#b0b0b8"},
    ],
    cards: [
      {n:"AU-AB", name:"Ahmed Best", artist:"Jar Jar Binks"},
      {n:"AU-AR", name:"Al Rodrigo", artist:"Quinlan Vos"},
      {n:"AU-BH", name:"Brian Herring", artist:"BB-8"},
      {n:"AU-CB", name:"Crispian Belfrage", artist:"Devastator Captain"},
      {n:"AU-DC", name:"Dan Considine", artist:"Densin Clord"},
      {n:"AU-FJ", name:"Felicity Jones", artist:"Jyn Erso"},
      {n:"AU-GE", name:"Giancarlo Esposito", artist:"Moff Gideon"},
      {n:"AU-GF", name:"Gabriel Fonseca", artist:"Duke Kayo Organa"},
      {n:"AU-ID", name:"Indie DesRoches", artist:"Corran"},
      {n:"AU-IM", name:"Ian McDiarmid", artist:"Emperor Palpatine"},
      {n:"AU-IV", name:"Indira Varma", artist:"Tala Durith"},
      {n:"AU-KF", name:"Karen Fukuhara", artist:"F"},
      {n:"AU-LC", name:"Lily Cole", artist:"Lovey"},
      {n:"AU-MQ", name:"Ming Qiu", artist:"Minas Velti"},
      {n:"AU-MW", name:"Ming-Na Wen", artist:"Fennec Shand"},
      {n:"AU-OD", name:"Olivia D'Abo", artist:"Luminara Unduli"},
      {n:"AU-RS", name:"Roberta Sparta", artist:"Duchess Celly Organa"},
      {n:"AU-TM", name:"Temuera Morrison", artist:"Boba Fett"},
    ]
  },
];
